import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';


function FamilyInfoUpdateRelatedFamilies() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const navigate = useNavigate();
    const location = useLocation();

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    
  const queryClient = useQueryClient();


  
      const {
          data: familyCaptions = [],
          isLoading: captionLoading,
          isError: captionError,
        } = useQuery({
          queryKey: ['selectFamilyCaptions'],
          queryFn: () =>
            axios.get(`${API_URL}/reg-signup-select-family-caption-api`).then((res) => {
              if (res.data.Status === "Success") return res.data.captions;
              else throw new Error("Caption fetch failed");
            }),
          staleTime: 0,
          cacheTime: Infinity,
        });
  
        const relatedFamilies = location.state?.relatedFamilies || [];
  

        const [isSubmitting, setIsSubmitting] = useState(false);

        const handleRequestSubmit = async (code) => {

            setIsSubmitting(true);

          try {
            const res = await axios.post(
              `${API_URL}/update-family-request-join-api`,
              { family_code: code },
              { withCredentials: true }
            );
        
            if (res.data.Status === "Success") {
              navigate(res.data.redirect);
            } else {
              toast.error("Failed to request Family.");
              setIsSubmitting(false);
            }
          } catch (error) {
            console.error("Request failed:", error);
            toast.error("Something went wrong.");
            setIsSubmitting(false);
          }
        };
     


  return (

    <div className='scrollPageContainer theme-light' >
    <div className='main-wrapper' >

            {/*start of header*/}
         {isSidebarVisible && <Sidebar />}
         <Header toggleSidebar={toggleSidebar} />
         {/*end of header */}
         {/*start of sidebar*/}
         <Sidebar show={showSidebar} toggle={toggleSidebar} />
         {/*End of sidebar*/}
         {/* start of footerbar */}
         <Footerbar toggleSidebar={toggleSidebar} />
         {/* end of footerbar */}
        <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">

            <div className='row'>

            <div className='col-md-12'>

            
             <div className="row" style={{marginTop: '2%'}}>
                <div className="col-3 col-md-3">
                </div>
                <div className="col-6 col-md-6 deleteacc-detail"> 
                <center>
            <label style={{fontWeight: '900'}}>Family you may know</label>
            </center>  
                </div>  
            </div>

            
                            <p >
                                <center>
            
                            {captionLoading ? 'Loading caption...' : (
                            familyCaptions.map((caption, index) => (
                            <span key={index}>{caption.caption}</span>
                            ))
                            )}
                            </center>
                            </p>
            
                            <div style={{overflowY: 'auto', height: '50vh', marginBottom: '1%'}}>
            
                            {relatedFamilies.map((family, index) => (
                            <div key={index} className="card mb-2 p-2">
                                <h5>{family.name}</h5>
                                
                                {family.admin && family.admin.length > 0 && (
                                <p>
                                  <li>
                                  {family.admin
                                    .map(a => `${a.n_prefix || ''} ${a.name} ${a.last_name}`) 
                                    .join(", ")}  
                                   
                                  </li>
                                  
                                </p>
                                )}
                                <div className='row'>
                                  <div className='col-md-12'>
                                  <center>
                                    <button onClick={() => handleRequestSubmit(family.family_code)} className='btn btn-primary'>Request to join</button>
                                  </center>
                                  </div>
                                </div>
                            </div>
                            ))}
            
                            </div>
            
                    
            
                            
                                <div className='d-flex justify-content-between align-items-center' >
            
            
                                    <Link onClick={() => navigate(-1)} class="btn btn-primary">
                                        &emsp;<i class="fa fa-arrow-left btn_arrow"></i>&emsp;</Link>
                                    
                                    
                                    <Link to='/family-info-update-clan' className="btn btn-primary" type="submit">
                                    Didn't find family</Link>
                                    
                                </div>
                                

                                <div className='row end-page-space' >  </div>



            </div>

             
            </div>

          </div>
        </div>
      </div>
      </div>
  );
}

export default FamilyInfoUpdateRelatedFamilies;
